module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icon_lpo03-97292fddfc17964d1523e6a12a42820a.svg";